import "./Cliente.css";
import { useEffect, useState, useRef } from "react";
import axios from "axios";

const Cliente = ({ slug, colorPrimario, colorSecundario }) => {
  console.log("📌 Slug recibido en Cliente:", slug);

  // 🔽 TODAS LAS URLs SEGÚN ENTORNO
  const baseUrl = process.env.REACT_APP_BASE_URL || "http://localhost:3000";
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";
  const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

  // 🔽 URLs DIRECTAS DE LOS ICONOS
  const llamarIcon = "https://tudcard.com/img/icono_llamar.png";
  const emailIcon = "https://tudcard.com/img/email.png";
  const whatsappIcon = "https://tudcard.com/img/whatsapp.png";
  const descargaContact = "https://tudcard.com/img/descarga-ok.png";
  const compartirIcon = "https://tudcard.com/img/compartir.png";
  const compartir2Icon = "https://tudcard.com/img/compartir2.png";
  const avatarDefault = "https://tudcard.com/img/avatar-default.png";
  const iconoDefault = "https://tudcard.com/img/icono-default.png";

  const [persona, setPersona] = useState(null);
  const [empresa, setEmpresa] = useState(null);
  const [error, setError] = useState(null);
  const [mostrarQR, setMostrarQR] = useState(false);

  const qrRef = useRef(null);

  const getApiUrl = (endpoint) => {
    const path = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
    return `${apiBaseUrl}${path}`;
  };

  const handleWhatsAppShare = () => {
    if (!empresa) return;
    const message = `Hola somos ${empresa.razon_social}. Te comparto nuestra tarjeta digital ${baseUrl}/#/cliente/${slug}/perfil`;
    window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`, "_blank");
  };

  const toggleQR = () => setMostrarQR((prev) => !prev);

  useEffect(() => {
    if (mostrarQR && qrRef.current) {
      qrRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [mostrarQR]);

  useEffect(() => {
    const obtenerPerfil = async () => {
      try {
        if (!slug) return;
        const response = await axios.get(getApiUrl(`/personas/${slug}`));
        if (!response.data.persona || !response.data.empresa) {
          throw new Error("No se encontraron datos para este perfil");
        }
        setPersona(response.data.persona);
        setEmpresa(response.data.empresa);
      } catch (err) {
        console.error("❌ Error al obtener perfil:", err);
        setError(err.message || "Error desconocido");
      }
    };
    obtenerPerfil();
  }, [slug]);

  // 🔥 NUEVA FUNCIÓN: DESCARGAR CONTACTO DINÁMICO (VCF)
  const descargarVcf = () => {
    if (!persona || !empresa) return;

    // Formatear dirección para el estándar VCard
    const direccionVCard = `;;${empresa.direccion || ""};Marinilla;Antioquia;;Colombia`;

    const vcardContent = [
      "BEGIN:VCARD",
      "VERSION:3.0",
      `FN:${persona.nombre || ""}`,
      `ORG:${empresa.razon_social || ""}`,
      `TITLE:${persona.cargo || ""}`,
      `TEL;TYPE=CELL:${persona.celular || ""}`,
      `EMAIL;TYPE=INTERNET:${persona.correo_electronico || ""}`,
      `URL:${persona.link_pagina_web || ""}`,
      `ADR;TYPE=WORK:${direccionVCard}`,
      "END:VCARD"
    ].join("\r\n");

    const blob = new Blob([vcardContent], { type: "text/vcard;charset=utf-8" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${persona.nombre || 'contacto'}.vcf`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  if (!persona || !empresa) return null;

  const { nombre, cargo, celular, correo_electronico, link_whatsapp, link_foto } = persona;
  const { link_qr } = empresa;

  return (
    <div className="cliente-card">
      {/* HEADER */}
      <div className="cliente-header" style={{ backgroundColor: colorPrimario }}>
        <h2 className="subtitulo-inferior marquee" style={{ color: colorSecundario }}>
          ¡Con D-Card, tus ventas CRECEN!
        </h2>
        <img
          src={link_foto}
          alt={nombre}
          className="cliente-foto"
          style={{ border: `4px solid ${colorSecundario}` }}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = avatarDefault;
          }}
        />
      </div>

      {/* INFO */}
      <div className="cliente-info">
        <h4 style={{ color: colorPrimario }}>{nombre}</h4>
        <h5><strong>{cargo}</strong></h5>

        <div className="social-links">
          {/* Llamar */}
          <a href={`tel:${celular}`}>
            <div className="social-icon-box">
              <img src={llamarIcon} alt="Llamar" className="iphone" />
              <span className="icon-label"><strong>Llamar</strong></span>
            </div>
          </a>

          {/* Correo */}
          <a href={`mailto:${correo_electronico}`}>
            <div className="social-icon-box">
              <img src={emailIcon} alt="Correo" className="iphone" />
              <span className="icon-label"><strong>Correo</strong></span>
            </div>
          </a>

          {/* WhatsApp */}
          <a href={link_whatsapp} target="_blank" rel="noopener noreferrer">
            <div className="social-icon-box">
              <img src={whatsappIcon} alt="WhatsApp" className="iphone" />
              <span className="icon-label"><strong>WhatsApp</strong></span>
            </div>
          </a>

          {/* 🔥 BOTÓN DESCARGAR CONTACTO (Actualizado a función JS) */}
          <div className="social-icon-box" onClick={descargarVcf} style={{ cursor: "pointer" }}>
            <img
              src={descargaContact}
              alt="Contacto"
              className="iphone"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = iconoDefault;
              }}
            />
            <span className="icon-label"><strong>Contacto</strong></span>
          </div>

          {/* Compartir WhatsApp */}
          <div className="social-icon-box" onClick={handleWhatsAppShare} style={{ cursor: "pointer" }}>
            <img src={compartir2Icon} alt="Compartir" className="iphone" />
            <span className="icon-label"><strong>Compartir Wp</strong></span>
          </div>

          {/* Compartir QR */}
          <div className="social-icon-box" onClick={toggleQR} style={{ cursor: "pointer" }}>
            <img src={compartirIcon} alt="QR" className="iphone" />
            <span className="icon-label"><strong>Escanear QR</strong></span>
          </div>
        </div>
      </div>

      {/* SECCIÓN QR */}
      {mostrarQR && (
        <section className="seccion-codigo-qr" ref={qrRef}>
          <div className="cliente-inf">
            <div className="social-redes">
              <div className="cuadrado-con-borde-int">
                <div className="borde-interno-rojo" style={{ border: `3px solid ${colorPrimario}` }}>
                  <img
                    src={link_qr}
                    alt="QR de contacto"
                    className="tarjeta-qr-imagen"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = iconoDefault;
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </div>
  );
};

export default Cliente;